import { useState, useEffect } from 'react';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../services/firebase';

export default function useGameHistory(userId) {
  const [games, setGames] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!userId) {
      setGames([]);
      setLoading(false);
      return;
    }

    let cancelled = false;

    async function fetchHistory() {
      setLoading(true);
      try {
        const q = query(
          collection(db, 'games'),
          where('playerIds', 'array-contains', userId),
          where('status', '==', 'finished')
        );
        const snapshot = await getDocs(q);

        const history = snapshot.docs.map(doc => {
          const data = doc.data();
          const userPlayer = data.players?.find(p => p.id === userId);
          const isWin = data.winner?.id === userId;

          return {
            id: doc.id,
            date: data.createdAt?.toDate?.() || new Date(),
            players: data.players || [],
            playerCount: data.players?.length || 0,
            userScore: userPlayer?.score || 0,
            winnerName: data.winner?.name || 'Unknown',
            isWin,
            gamePhotoUrl: data.gamePhotoUrl || null,
            venueName: data.venueId || '',
          };
        });

        history.sort((a, b) => b.date - a.date);
        if (!cancelled) setGames(history);
      } catch (e) {
        console.error('Error fetching game history:', e);
        if (!cancelled) setGames([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    fetchHistory();
    return () => { cancelled = true; };
  }, [userId]);

  return { games, loading };
}
